export function initVideoPlayer(): void {
  const videoAreas = document.querySelectorAll<HTMLElement>('.js-video-area');

  videoAreas.forEach((area) => {
    const video = area.querySelector<HTMLVideoElement>('.js-video-item');
    const button = area.querySelector<HTMLButtonElement>('.js-video-btn');

    if (!video || !button) return;

    button.addEventListener('click', async () => {
      try {
        await video.play();
        button.hidden = true;
      } catch (error) {
        console.error(error);
      }
    });

	  video.addEventListener('click', () => {
		  if (video.paused) {
			  video.play();
			  button.hidden = true;
		  } else {
			  video.pause();
			  button.hidden = false;
		  }
	  });

    video.addEventListener('ended', () => {
      button.hidden = false;
    });
  });
}
